import type React from 'react'

type props = {
  children: React.ReactNode[]
}
export const Section: React.FC<props> = ({ children }) => {
  const [title, ...explanations] = children

  return (
    <div>
      <div className="fr">{title}</div>
      <div className="mb20">
        {explanations.map((explanation, i) => (
          <div key={i}>{explanation}</div>
        ))}
      </div>
    </div>
  )
}
